export class MicrosoftIsEntityAuthorizedRequest{
    public customerId!:number;
    public clientIds:number[]=[];
}
